import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Category, Props } from '../Category/Category';
import { Wrapper } from './SortableCategory.styles';

export const SortableCategory = (props: Props) => {
  const { category } = props;

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: category.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Wrapper
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      css={{ opacity: isDragging ? 0 : 1 }}
    >
      <Category {...props} />
    </Wrapper>
  );
};
